<template>
  <div
    class="flex w-full items-center"
    style="position: relative;"
    @click.stop
    @click.prevent
  >
    <div v-if="listType !== 'inviting'" class="flex justify-start items-center">
      <vs-avatar
        :src="avatar"
        :text="avatarText"
        class="flex-shrink-0 mr-2"
        :color="AISEA_COLOR.LIGHT_BLUE"
        size="30px"
        @click="onClickNameLink"
      />

      <p @click="onClickNameLink" class="text-inherit link-string">
        {{ params.value }}
      </p>
    </div>
    <div v-if="listType === 'inviting'">
      <div class="flex justify-start items-center" style="padding: 0.1rem;">
        <vs-avatar
          :src="avatar"
          :text="avatarText"
          class="flex-shrink-0 mr-4"
          size="30px"
          :color="AISEA_COLOR.LIGHT_BLUE"
          style="cursor: default;"
        />
        <div style="line-height: 1.2rem;">
          <vs-row>
            <vs-col vw-12
              ><div
                class="flex justify-center mt-1"
                :style="{
                  'background-color': '#00BCD4',
                  color: AISEA_COLOR.WHITE,
                }"
                style="border-radius: 0.2rem; width: 4rem; padding: 0.1rem"
              >
                招待中
              </div></vs-col
            >
          </vs-row>
          <vs-row>
            <vs-col vw-12
              ><div class="mt-1">期限：{{ dispExpired }}</div></vs-col
            >
          </vs-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ColorMixin } from "@/mixins";
import { storage } from "@/firebase/firebaseConfig";
import moment from "moment-timezone";

export default {
  name: "CellRendererLink",
  mixins: [ColorMixin],
  data() {
    return {
      avatar: null,
      avatarText: "",
      listType: "",
    };
  },
  computed: {
    dispExpired() {
      return this.params.data.expired_at
        ? moment(this.params.data.expired_at)
            .local()
            .format("YYYY/MM/DD HH:mm:ss")
        : null;
    },
  },
  created() {
    this.listType = this.params.context.componentParent.listType;

    if (this.params.data.picture) {
      storage
        .child(this.params.data.picture.thumbnail_path)
        .getDownloadURL()
        .then(response => {
          this.avatar = response;
        });
    } else {
      this.avatarText = this.params.data.full_name
        ? this.params.data.full_name.charAt(0)
        : "";
    }
  },
  methods: {
    onClickNameLink() {
      this.$router.push({
        name: "enterprise-management-admin-account-detail",
        params: { id: this.params.data.enterprise_account_id },
      });
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
.link-string {
  color: $aisea-blue;
  cursor: pointer;
}
</style>
